/* eslint-disable jsx-a11y/anchor-is-valid */
import ct from "class-types.macro";
import React, { useMemo, useState } from "react";

interface Props {
  reviewText: string;
}

const TextReviewContent = ({ reviewText }: Props) => {
  const [readMore, setReadMore] = useState(false);

  const words = useMemo(() => reviewText.split(" "), [reviewText]);
  const visibleText = useMemo(
    () => (words.length > 0 ? words.slice(0, 150).join(" ") : ""),
    [words],
  );
  const hiddenText = useMemo(
    () => (words.length > 0 ? words.slice(150).join(" ") : ""),
    [words],
  );

  return (
    <>
      {words.length > 185 && (
        <p
          className={`product-review__text ${ct(
            "text-base",
            "pt-4",
            "pb-5",
            "m-0",
          )}`}
        >
          {visibleText}
          {readMore && (
            <span className="product-review__text">
              &nbsp;{hiddenText}
              <a
                href="#"
                className="product-review__collapse cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  setReadMore(false);
                }}
              >
                &nbsp;Read Less
              </a>
            </span>
          )}
          {!readMore && (
            <a
              href="#"
              className="product-review__expand cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                setReadMore(true);
              }}
            >
              &nbsp;Read More
            </a>
          )}
        </p>
      )}
      {words.length > 0 && words.length <= 185 && (
        <p
          className={`product-review__text ${ct(
            "text-base",
            "pt-4",
            "pb-5",
            "m-0",
          )}`}
        >
          {reviewText}
        </p>
      )}
    </>
  );
};

export default TextReviewContent;
